import React, { forwardRef, Ref } from "react";

import classnames from "classnames/bind";
import styles from "./PieChartLegend.module.scss";

import { Legend } from "../../components/Legend";

import { LEGEND_MARGIN } from "./constants";

import type { PieChartLegendProps } from "../types";

const cx = classnames.bind(styles);

const PieChartLegend = (
  { scale, onMouseOver, active, orientation, data }: PieChartLegendProps,
  legendRef: Ref<HTMLDivElement>
) => {
  return (
    <div
      ref={legendRef}
      className={cx("container", {
        vertical: orientation === "vertical",
        horizontal: orientation === "horizontal",
      })}
      style={
        orientation === "horizontal"
          ? { marginTop: LEGEND_MARGIN }
          : { marginLeft: LEGEND_MARGIN }
      }
    >
      <Legend
        scale={scale}
        orientation={orientation}
        onMouseOver={onMouseOver}
        active={active}
        data={data}
      />
    </div>
  );
};

export default forwardRef(PieChartLegend);
